import React from "react";
import { Navigate, Outlet } from "react-router-dom";
// import { useSelector } from "react-redux"; // or Context if you use it
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ allowedRoles }) => {

    // const user = JSON.parse(localStorage.getItem("user"));
    const { user, isAuthenticated } = useAuth();
  
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
      }
    
      const hasAccess = allowedRoles.includes(user.role.name);
    
      return hasAccess ? <Outlet /> : <Navigate to="/403" replace />;
    };
    
    export default ProtectedRoute;